import type { CoreConsentLegalDocumentResponse } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  CoreConsentLegalDocument,
  useGetCoreConsentLegalDocument,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { SWRResponse } from "swr"
import useSWR from "swr"
import { usePolyglot } from "src/contexts"

export function useTermsOfUseConsentDocument(): SWRResponse<CoreConsentLegalDocumentResponse> {
  const polyglot = usePolyglot()
  const getLegalDocument = useGetCoreConsentLegalDocument()

  const language = useMemo(

    () => new Intl.Locale(polyglot.locale()).language,
    [polyglot],
  )

  const swrKey = useMemo(
    () => {
      const url = `/api/v3/consent_tracking/${CoreConsentLegalDocument.TermsOfUse}`

      return {
        url,
        params: {
          language,
        },
      }
    },
    [language],
  )

  const getTermsOfUseConsentDocument = useMemo(
    () => !getLegalDocument
      ? null
      : async () => {
        const response = await getLegalDocument(
          CoreConsentLegalDocument.TermsOfUse,
          language,
        )
        return response.data
      },
    [
      language,
      getLegalDocument,
    ],
  )

  return useSWR<CoreConsentLegalDocumentResponse>(
    swrKey,
    getTermsOfUseConsentDocument,
  )
}
